<template>
  <component
    :is="tag"
    :style="{
      fontSize: parseSize(size!),
      textAlign: align,
      'vertical-align': verticalAlign,
      fontWeight:weight,
      textTransform:transform,
      letterSpacing:space ? '0.1em' : '',
      color:pallette[color as 'primary'] || parseColor(color!),
      backgroundColor:pallette[bgColor as 'primary'] || parseColor(bgColor!),
    }"
    :class="[verticalAlign ? 'v-align-' + verticalAlign : '']"
  >
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
import { pallette } from "@/utils/colors";

withDefaults(
  defineProps<{
    /** default - span */
    // eslint-disable-next-line no-undef
    tag?: keyof HTMLElementTagNameMap;
    /** vuetify theme available colors
     *
     * default chsGray900
     */
    color?: keyof typeof pallette | `#${string}` | `c-${string}`;
    bgColor?: keyof typeof pallette | `#${string}` | `c-${string}`;
    /**
     * c1 - 4px
     *
     * c2 - 8px
     *
     * c3 - 12px
     * ...
     * {number}{measure - rem, px ...}
     *
     *
     * default - 1rem
     */
    size?: string;
    align?: "center" | "end" | "start" | "unset";
    verticalAlign?: "start" | "end" | "center" | "unset";
    weight?: string;
    transform?: string;
    space?: boolean;
  }>(),
  {
    tag: "span",
    color: "gray900",
    size: "1rem",
    align: undefined,
    verticalAlign: undefined,
    weight: "unset",
    transform: ""
  }
);

const parseSize = (size: string) => {
  if (/^c[1-9]*$/.test(size)) return +size.replace("c", "") * 4 + "px";
  return size;
};
const parseColor = (color: string) => {
  if (/^c-[a-zA-Z]*$/.test(color)) return color.replace("c-", "");
  return color;
};
</script>

<style scoped lang="scss">
.v-align-start {
  vertical-align: top;
}
.v-align-end {
  vertical-align: bottom;
}
.v-align-center {
  vertical-align: center;
}
.v-align-unset {
  vertical-align: unset;
}
</style>
